import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import FixedBox from '../../atoms/layout/FixedBox'
import Image from '../../atoms/display/Image'
import AbsoluteBox from '../../atoms/layout/AbsoluteBox'
import IconButton from '../../atoms/inputs/IconButton'
import { CloseIcon } from '../../atoms/display/Icons'
import Link from '../../atoms/navigation/Link'
import { useDeviceType } from '../../../hooks/useDeviceType'
import { FlexRow } from '../../atoms/layout/Flex'
import RelativeBox from '../../atoms/layout/RelativeBox'
import { SessionSelectors } from '../../../store/session/selectors'
import sessionSlice from '../../../store/session'
import { MoneyspacesSelectors } from '../../../store/moneyspaces/selectors'

export default function FactoringBanner() {
  const { pc } = useDeviceType()
  const displayFactoringBanner = useSelector(SessionSelectors.displayFactoringBanner)
  const dispatch = useDispatch()
  const companyId = useSelector(SessionSelectors.companyId)
  const moneyspaces = useSelector(MoneyspacesSelectors.moneyspaces)
  const isContractee = moneyspaces.filter((ms) => ms.contractee?.id === companyId).length >= 5
  const exclusionCompany = moneyspaces.some((ms) => ['med', 'medw', 'mede'].includes(ms.contractee?.uid ?? ''))
  const [waiting, setWaiting] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setWaiting(false)
    }, 5000)
  }, [])

  const handleClose = () => {
    dispatch(sessionSlice.actions.setDisplayFactoringBanner(false))
  }

  if (isContractee || !displayFactoringBanner || waiting || exclusionCompany) {
    return <></>
  }
  if (pc) {
    return (
      <FixedBox right={32} bottom={16} zIndex={1000}>
        <Link href="https://docs.google.com/forms/d/1-0I__zQbr6uFRDnvwtc1zLdaRr5f_pQBrx4QJENi1tk/preview">
          <Image url="/factoring_banner_pc.jpg" alt="バナー" width={240} height={240} />
        </Link>
        <AbsoluteBox right={0} top={0}>
          <IconButton label="close" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </AbsoluteBox>
      </FixedBox>
    )
  }
  return (
    <FixedBox bottom={16} left={0} right={0} zIndex={1000}>
      <FlexRow justify="center" width="100%">
        <RelativeBox width="320px">
          <Link href="https://docs.google.com/forms/d/1-0I__zQbr6uFRDnvwtc1zLdaRr5f_pQBrx4QJENi1tk/preview">
            <Image url="/factoring_banner_sp.jpg" alt="バナー" width={320} height={100} />
          </Link>
          <AbsoluteBox right={0} top={0}>
            <IconButton label="close" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </AbsoluteBox>
        </RelativeBox>
      </FlexRow>
    </FixedBox>
  )
}
